import type { ApplicationState } from '../types';

export const selectIsLoadingByResource = (state: ApplicationState) =>
  state.loading.isLoadingByResource;
